module.exports = __webpack_public_path__ + "static/media/IBMPlexSans-Light.fe6a0ca5.woff2";